import { iPrice, iTask } from "@/services";

/**
 * 단가 그룹 목록을 조회합니다.
 * @param {number|string} projectId 프로젝트 ID
 * @returns {Promise<Array>} 단가 그룹 목록
 */
export async function getPriceGroups(projectId) {
  try {
    const payload = { projectId };
    const response = await iPrice.getPriceGroups(payload);

    if (response && response.data && response.data.payload) {
      return response.data.payload.groups || [];
    }
    return [];
  } catch (error) {
    console.error("단가 그룹 목록을 불러오는 중 오류 발생:", error);
    return [];
  }
}

/**
 * 단가 정보를 조회합니다.
 * @param {number} priceId 단가 ID
 * @returns {Promise<Object>} 단가 정보
 */
export async function getPriceInfo(priceId) {
  try {
    const res = await iPrice.getPriceInfo(priceId);
    if (res && res.data && res.data.payload) {
      return res.data.payload;
    }
    return null;
  } catch (error) {
    console.error("단가 정보 조회 중 오류 발생:", error);
    return null;
  }
}

/**
 * 단가 변경 내역을 조회합니다.
 * @param {Object} options 조회 옵션
 * @returns {Promise<Object>} 단가 변경 내역
 */
export async function getPriceHistories(options) {
  try {
    const res = await iPrice.getPriceHistories(options);
    if (res && res.data && res.data.payload) {
      return res.data.payload;
    }
    return { count: 0, histories: [] };
  } catch (error) {
    console.error("단가 변경 내역 조회 중 오류 발생:", error);
    return { count: 0, histories: [] };
  }
}

/**
 * 단가를 설정합니다.
 * @param {Object} payload 단가 설정 데이터
 * @returns {Promise<Object>} 설정 결과
 */
export async function setPriceInfo(payload) {
  try {
    const res = await iPrice.priceSetting(payload);
    return res?.data || null;
  } catch (error) {
    console.error("단가 설정 중 오류 발생:", error);
    return null;
  }
}

/**
 * 단가 그룹 상세 정보를 조회합니다.
 * @param {number} groupId 단가 그룹 ID
 * @returns {Promise<Object>} 단가 그룹 상세 정보
 */
export async function getPriceGroupDetail(groupId) {
  try {
    const response = await iPrice.getPriceGroupDetail(groupId);
    if (response && response.data && response.data.payload) {
      return response.data.payload;
    }
    return null;
  } catch (error) {
    console.error("단가 그룹 상세 정보 조회 중 오류 발생:", error);
    return null;
  }
}

/**
 * 프로젝트명을 조회합니다.
 * @param {number|string} projectId 프로젝트 ID
 * @returns {Promise<string>} 프로젝트명
 */
export async function getProjectName(projectId) {
  try {
    const res = await iTask.getProjectsName({ id: projectId });
    if (res && res.data && res.data.payload) {
      return res.data.payload;
    }
    return "";
  } catch (error) {
    console.error("프로젝트명 조회 중 오류 발생:", error);
    return "";
  }
}
